import { NavItemType } from 'types';
import main from './main';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [main]
};

export default menuItems;
